// extracted by mini-css-extract-plugin
module.exports = {"readonlyForm":"UpdateIngredient_readonlyForm__2JGQb"};